<template>
  <div>
    <div v-if="!url" data-v-377afdca="" class="loading-mask-container">
      <div data-v-377afdca="" class="loading-icon-wrapper"><img data-v-377afdca="" src="/static/image/rotate.963673.png" alt="" class="loading-rotate-img" /></div>
    </div>
    <div v-else style="height: calc(100vh - 50px); overflow-y: scroll; -webkit-overflow-scrolling: touch">
      <!-- <iframe style="height: 100%; width: 100%" :src="url" scrolling="auto" frameborder="0" class="trend-container2" id="iframe"></iframe> -->
      <iframe style="height: 100%; width: 100%" ref="iframe" scrolling="auto" frameborder="0" id="iframe"></iframe>
      <!--  -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
    };
  },
  created() {
    let that = this;
    that.$apiFun.post('/api/getservicerurl', {}).then(res => {
      if (res.code != 200) {
        that.showTost(0, res.message);
      }
      if (res.code == 200) {
        that.url = res.data.url;
      }
    });
  },
  methods: {},
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
    that.$refs.iframe.contentWindow.location.replace(that.url);
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-099d4415.690b75b1.css';
</style>



// WEBPACK FOOTER //
// src/components/main/kefu.vue